import React from 'react'
import Select, { Props } from 'react-select'
import { states } from '@evertel/constants'

interface StateSelectProps extends Omit<Props, 'value' | 'onChange'> {
    selected?: any[]
    isMulti?: boolean
    placeholder?: string
    onSelect: (any) => void
}

const StateSelect: React.FC<StateSelectProps> = ({
    selected,
    isMulti,
    placeholder = 'Select...',
    onSelect,
    ...otherProps
}) => {

    const _onSelect = (e) => {
        onSelect && onSelect(e)
    }

    return (
        <Select
            name="state"
            options={states}
            value={selected}
            onChange={_onSelect}
            isMulti={isMulti}
            placeholder={placeholder}
            className="react-select"
            classNamePrefix="select"
            {...otherProps}
        />
    )
}

export { StateSelect }
